export default __webpack_public_path__ + "static/media/B_05_06_grafik.4bc72bc1.png";